import { heroGirlCombingDog } from 'assets/images';
import { PoweredByCuddles } from 'components/Cuddles/PoweredBy/PoweredByCuddles';
import { LeftColumn } from 'components/Layout/TwoColumns/LeftColumn/LeftColumn';
import { RightImageColumn } from 'components/Layout/TwoColumns/RightImageColumn/RightImageColumn';
import { TwoColumnsLayout } from 'components/Layout/TwoColumns/TwoColumnsLayout';
import { MarketplaceInfo } from 'components/Marketplace/Info/MarketplaceInfo';
import { OnlineBookingSigninForm } from 'components/OnlineBooking/Steps/Signin/Form/OnlineBookingSigninForm';
import { useMarketplace } from 'hooks/useMarketplace';
import React from 'react';
import { dispatch } from 'store';
import { navigateToStep } from 'actions/onlineBooking/actions/OnlineBookingFlowActions';
import { OnlineBookingHeader } from 'components/OnlineBooking/Header/OnlineBookingHeader';
import { OnlineBookingStep } from 'types/OnlineBooking';
import classes from './OnlineBookingSigninStep.module.scss';

export const OnlineBookingSigninStep: React.FC = () => {
    const marketplace = useMarketplace();

    const backHandler = React.useCallback(() => {
        dispatch(navigateToStep(OnlineBookingStep.Home));
    }, []);

    return (
        <TwoColumnsLayout header={<OnlineBookingHeader onBack={backHandler} />}>
            <LeftColumn contentClassName="flex flex-col flex-1">
                <div className={classes.content}>
                    <MarketplaceInfo marketplace={marketplace} />

                    <OnlineBookingSigninForm />
                </div>

                <div className="pt-6 mt-auto hide-on-mobile-and-tablet">
                    <PoweredByCuddles />
                </div>
            </LeftColumn>

            <RightImageColumn
                image={marketplace.onlineBookingPreferences.promoImageUrl ?? heroGirlCombingDog}
            />
        </TwoColumnsLayout>
    );
};
